require('../proposals/global-this');
require('../proposals/promise-all-settled');
require('../proposals/string-match-all');
var path = require('../internals/path');

module.exports = path;
